// Used as the uuid for the default "Search Dash" option in the typeahead
export const SEARCH_DASH_UUID = "8692324a-aea3-5f5b-b48d-cd46d888fc05";
export const ASK_DASH_UUID = "8692324a-aea3-5f5b-b48d-cd46d888fc06";
export const ORGANIZE_DASH_UUID = "8692324a-aea3-5f5b-b48d-cd46d888fc07";
export const WRITE_DASH_UUID = "8692324a-aea3-5f5b-b48d-cd46d888fc08";

export type PreviousQuery = {
  uuid: string;
  query: string;
};
